import { Timestamp, Unsubscribe } from "firebase/firestore";
import { useUserProfileStore } from "@/store/UserProfile";
import { computed, Ref, ref } from "vue";
import PokerRunEventDataService from "@/services/PokerRunEventDataService";
import { LeaderboardItem } from "@models/LeaderboardItem";
import { sortUtils } from "@/utils/sortUtils";

export default function useLeaderboard(): {
  leaderboard: Ref<LeaderboardItem[]>;
  participantLeaderboard: Ref<LeaderboardItem | undefined>;
  getLeaderboard: (eventId: string, participantIds: string[]) => void;
  totalParticipants: Ref<number>;
  unsubscribeLeaderboard: () => void;
  // eslint-disable-next-line indent
} {
  const { profile } = useUserProfileStore();
  const leaderboard = ref<LeaderboardItem[]>([]);
  let unsubscribe: Unsubscribe | null;

  const unsubscribeLeaderboard = () => {
    if (unsubscribe) {
      unsubscribe();
    }
  };

  const participantLeaderboard = computed(() => {
    const userLeaderboard = leaderboard.value?.find((x) => x.participantId === profile.id);
    return userLeaderboard;
  });

  const handleLeaderboardChange = (updatedLeaderboard: {
    positions: LeaderboardItem[];
    createTimestamp: Timestamp;
  }) => {
    leaderboard.value = updatedLeaderboard.positions;
  };

  const getLeaderboard = async (eventId: string, participantIds: string[]) => {
    const result = await PokerRunEventDataService.getLeaderboard(
      eventId,
      participantIds,
      handleLeaderboardChange
    );
    var unranked = result?.leaderboard.positions.filter(x=>x.rank.cardCount === 0);
    var ranked = result?.leaderboard.positions.filter(x=>x.rank.cardCount > 0);
    unranked.sort(sortUtils.byName)
    leaderboard.value = [...ranked, ...unranked];
    unsubscribe = result.unsubscribe;
  };

  const totalParticipants = computed(() => {
    // count of distinct userids
    return [...new Set(leaderboard.value.map((x) => x.userId ?? x.participantName))].length;
  });

  return {
    leaderboard,
    participantLeaderboard,
    getLeaderboard,
    totalParticipants,
    unsubscribeLeaderboard,
  };
}
